import { PublicKey } from '@solana/web3.js';
import { getSolanaConnection } from '../connection';
import { decodeVaultState } from '../decoders/vaultState';

const EMPTY_PUBLIC_KEY = PublicKey.default.toBase58();

function normalizeReserveVaultPubkey(value) {
  if (!value || value === EMPTY_PUBLIC_KEY) {
    return '';
  }

  return value;
}

export async function fetchCurrentReserveVault(reserveVaultPubkey) {
  const connection = getSolanaConnection();
  const normalizedReserveVaultPubkey = normalizeReserveVaultPubkey(reserveVaultPubkey);

  if (!normalizedReserveVaultPubkey) {
    return {
      publicKey: '',
      lamports: null,
      data: null,
    };
  }

  const accountInfo = await connection.getAccountInfo(
    new PublicKey(normalizedReserveVaultPubkey),
    'confirmed'
  );

  if (!accountInfo) {
    throw new Error('Current reserve vault account was not found.');
  }

  return {
    publicKey: normalizedReserveVaultPubkey,
    lamports: accountInfo.lamports,
    data: decodeVaultState(accountInfo.data),
  };
}
